function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_32_"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_18_",
  className: "st0",
  points: "19.9,78.2 33.3,97.6 66.2,114.3 93.5,102.5 110,79.2 110,49.6 94.6,27.4 66.9,15.7  39.5,25.3 21.8,49.2  "
}), /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_20_",
  className: "st0",
  points: "48.5,74.6 77.8,78.5 92.4,51 67.4,32.8 39.5,49.2  "
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_21_",
  className: "st0",
  x1: 77.8,
  y1: 78.5,
  x2: 93.4,
  y2: 102.5
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_22_",
  className: "st0",
  x1: 48.5,
  y1: 74.6,
  x2: 33.3,
  y2: 97.6
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_23_",
  className: "st0",
  x1: 40,
  y1: 50,
  x2: 23,
  y2: 50
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_24_",
  className: "st0",
  x1: 67.4,
  y1: 32.8,
  x2: 66.9,
  y2: 15.7
}), /*#__PURE__*/React.createElement("line", {
  id: "XMLID_25_",
  className: "st0",
  x1: 92.4,
  y1: 51,
  x2: 109.9,
  y2: 49.6
}));
function SvgD12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD12);
export default __webpack_public_path__ + "static/media/d12.6f2618a7b636cf695bdf04bfdac113ae.svg";
export { ForwardRef as ReactComponent };